import React from 'react';
import { Building2, GraduationCap } from 'lucide-react';

/** An organization's logo, or a college/company glyph when it has none. Decorative. */
export const OrgLogo: React.FC<{
  org: { logoUrl?: string | null; type: 'COMPANY' | 'COLLEGE' | string };
  size?: number;
}> = ({ org, size = 40 }) => (
  <div
    aria-hidden="true"
    style={{
      width: size,
      height: size,
      borderRadius: Math.round(size / 4),
      background: 'var(--teal-2)',
      color: 'var(--teal-3)',
      display: 'grid',
      placeItems: 'center',
      flexShrink: 0,
      overflow: 'hidden',
    }}
  >
    {org.logoUrl ? (
      <img src={org.logoUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
    ) : org.type === 'COLLEGE' ? (
      <GraduationCap size={Math.round(size / 2)} />
    ) : (
      <Building2 size={Math.round(size / 2)} />
    )}
  </div>
);
